import {
  API_CALL,
  SET_SALES_COPILOT_OFFER_STAY,
  SET_SALES_COPILOT_PACKAGE_UPGRADED,
} from 'actions/actionConstants'
import {
  FETCH_SPOOF_LAUNCHPAD_OFFER_VIEWS,
  FETCH_SPOOF_USER_CARTS,
} from 'actions/apiActionConstants'
import { getMyCarts } from 'api/cart/getMyCarts'
import { getSpoofLaunchpadOfferViews } from 'api/salesLaunchpadActivity'
import config from 'constants/config'
import { getCurrentUserId } from 'selectors/accountSelectors'
import { isSpoofed } from 'selectors/isSpoofed'
import type { AppAction } from './types/ActionTypes'

const LAUNCHPAD_REFRESH_AFTER_MS = 30_000

interface LaunchpadFetchState {
  state: App.ApiResponseState
  cacheKey?: string
  requestedAt?: string
}

// The launchpad stays mounted while the agent browses, so refetch the same customer's data once it is 30s old.
function shouldFetchLaunchpadData(current: LaunchpadFetchState, cacheKey: string) {
  if (current.state === 'loading') return false
  if (current.state === 'initial' || current.cacheKey !== cacheKey || !current.requestedAt) return true
  return Date.now() - Date.parse(current.requestedAt) >= LAUNCHPAD_REFRESH_AFTER_MS
}

export function fetchSpoofLaunchpadOfferViews(): AppAction {
  return async(dispatch, getState) => {
    const state = getState()
    const customerId = getCurrentUserId(state)

    if (!customerId) return

    const cacheKey = customerId
    if (!shouldFetchLaunchpadData(state.aiOps.offerViews, cacheKey)) return

    dispatch({
      type: API_CALL,
      api: FETCH_SPOOF_LAUNCHPAD_OFFER_VIEWS,
      cacheKey,
      request: () => getSpoofLaunchpadOfferViews(customerId),
    })
  }
}

export function fetchSpoofUserCarts(): AppAction {
  return async(dispatch, getState) => {
    const state = getState()
    const memberId = getCurrentUserId(state)

    if (!memberId) return

    const cacheKey = `${memberId}_${config.BRAND}`
    if (!shouldFetchLaunchpadData(state.aiOps.userCarts, cacheKey)) return

    dispatch({
      type: API_CALL,
      api: FETCH_SPOOF_USER_CARTS,
      cacheKey,
      request: () => getMyCarts(),
    })
  }
}

export function setSalesCopilotOfferStay(offerStay: App.SalesCopilotOfferStay | undefined): AppAction {
  return { type: SET_SALES_COPILOT_OFFER_STAY, offerStay }
}

// Only spoofing agents see the Sales Co-Pilot, so customers never record the outcome.
export function setSalesCopilotPackageUpgraded(offerId: string, packageUpgraded: boolean): AppAction {
  return (dispatch, getState) => {
    if (!isSpoofed(getState())) return
    dispatch({ type: SET_SALES_COPILOT_PACKAGE_UPGRADED, offerId, packageUpgraded })
  }
}
